import Factory from '../factory';

const schema = Factory.schema('notice');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('title').setType(String).setValue('Title');
attributes.prop('image').setType(String).setValue('image-placeholder.svg');
attributes.prop('imageAlt').setType(String);
attributes.prop('strapline').setType(String).setValue('Strapline');
attributes.prop('btnText').setType(String).setValue('Read more');
attributes.prop('btnLink').setType(String).setValue('#');
attributes.prop('variant').setType(String).setValue('alpha');
attributes.prop('flip').setType(Boolean).setValue(false);

export default schema;
